import React from 'react'
import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar'


function NewReports() {
  return (
    <IncludeSideBar>
        <div>
            <p>
                here we are displaying the new Reports.
            </p>
        </div>
    </IncludeSideBar>
  )
}

export default NewReports